import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import filterThs from 'utils/filter-ths'
import styles from './table.styl'
import { Checkbox } from 'components/inputs'
import cx from 'classnames'


export default class TableHeader extends Component {
  static propTypes = {
    permissions: PropTypes.object,
    ths: PropTypes.array.isRequired,
    sort: PropTypes.string,
    onSortChange: PropTypes.func,
    areAllSelected: PropTypes.bool,
    bulkSelect: PropTypes.func,
  }

  static defaultProps = {
    permissions: {}
  }

  handleSortChange = sortableId => {
    const { sort, onSortChange } = this.props
    const sortIds = (sort && sort.split(',')) || []
    const currId = sortIds.filter(id => id.includes(sortableId)).join()
    let sortBy = sortableId

    if (!currId) {
      // sortIds = sortIds.concat(`-${sortableId}`)
      sortBy = `-${sortableId}`
    } else if (currId.includes('-')) {
      // sortIds = sortIds.filter(item => item !== `-${sortableId}`).concat(`+${sortableId}`)
      sortBy = `+${sortableId}`
    } else if (currId.includes('+')) {
      // sortIds = sortIds.filter(item => item !== `+${sortableId}`).concat(`-${sortableId}`)
      sortBy = `-${sortableId}`
    }

    onSortChange({
      // sort: sortIds.filter(item => Boolean(item)).reverse().join(',')
      sort: sortBy
    })
  }

  render() {
    const { ths, sort, onSortChange, permissions, areAllSelected } = this.props
    const filteredThs = filterThs(ths, permissions)

    return (
      <thead>
        <tr>
          {filteredThs.map(th => {
            const isActive =
              sort &&
              sort
                .split(',')
                .filter(item => {
                  let sortItem = item

                  if (sortItem.includes('+') || sortItem.includes('-')) {
                    sortItem = sortItem.slice(1, sortItem.length)
                  }

                  return sortItem === th.sortableId
                })
                .join()
            const upClass = isActive && isActive.includes('+') ? styles.up : ''
            const asideClass = th.right ? styles.right : ''

            return (
              <th key={th.id} className={cx(asideClass, th.className)}>
                <span className={styles.flexify}>
                  {th.intlKey
                    ? <FormattedMessage
                        id={th.intlKey}
                        defaultMessage={th.label}
                      />
                    : th.label}

                  {th.sortableId &&
                    onSortChange &&
                    <button
                      className={styles.btnSort}
                      onClick={() => this.handleSortChange(th.sortableId)}
                    >
                      <span
                        className={`ico ico--arrow-down ${styles.ico} ${upClass || ''} ${isActive ? styles.active : ''}`}
                      />
                    </button>}

                  {th.selector &&
                    <Checkbox
                      labelless
                      inTable
                      label=""
                      name="selectAll"
                      checked={areAllSelected}
                      onChange={this.props.bulkSelect}
                    />
                  }
                </span>
              </th>
            )
          })}
        </tr>
      </thead>
    )
  }
}
